import { LuCopy, LuGripVertical, LuTrash2 } from "react-icons/lu";
import { formEl } from "../../../../constants";
import input from "../input.module.css";
import ImageSelect from "../../../../Components/ImageSelect/ImageSelect.jsx";
const TextFieldInput = ({
  item,
  handleValue,
  deleteEl,
  handleRequired,
  handleElType,
  duplicateElement,
  disableDelete,
  isPreview = false,
}) => {
  return (
    <div className="bg-white drag-handle border border-gray-200 rounded-lg shadow-sm mb-4">
      <div className="text-center py-2 cursor-move">
        <LuGripVertical
          style={{ transform: "rotate(-90deg)", cursor: "all-scroll" }}
          className="inline-block text-gray-400"
          size={20}
        />
      </div>
      <div className="px-6 space-y-4 py-4">
        <div className="w-[300px]">
           <ImageSelect
            value={item.type}
            onChange={(value) => handleElType(item.id, value)}
            options={formEl}
            className={`${input.input_field} w-full`}
            disabled={isPreview}
          />
        </div>
        <div className="flex gap-2">
          <div className="flex-1">
            <input
              type="text"
              value={item.value || ""}
              onChange={(e) => !isPreview && handleValue(item.id, e)}
              placeholder="Question"
              required={item.required}
              className={input.input_field}
              disabled={isPreview}
            />
            <input
              type="text"
              placeholder="Placeholder"
              disabled
              className={input.input_field}
            />
          </div>
        </div>
      </div>
      <hr className="border-gray-200" />
      <div className="flex items-center px-4 py-2 gap-4">
        <button
          onClick={() => deleteEl(item.id)}
          disabled={disableDelete || isPreview}
          className="text-red-500 hover:text-red-700 p-2"
          title="Delete Element"
        >
          <LuTrash2 size={18} />
        </button>
        <button
          onClick={() => duplicateElement(item.id, item.type)}
          disabled={isPreview}
          className="text-gray-600 hover:text-gray-800 p-2"
          title="Duplicate Element"
        >
          <LuCopy size={18} />
        </button>
        <label className="flex items-center gap-2 ml-auto cursor-pointer">
          <input
            type="checkbox"
            checked={item.required}
            onChange={() => handleRequired(item.id)}
            className="w-4 h-4"
            disabled={isPreview}
          />
          <span className="text-sm">Compulsory</span>
        </label>
      </div>
    </div>
  );
};

export default TextFieldInput;
